import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { SimpleUser, User } from 'app/models';
import { Equipment } from 'app/modules/dashboard/models/equipment.model';
import { Settings } from 'app/modules/dashboard/models/settings.model';
import { PaginableUsersHttpResult } from 'app/modules/dashboard/models/users.model';
import { CurrencyType } from 'app/services/gift-cards-plans.service';

export const MeActions = createActionGroup({
  source: 'Me API',
  events: {
    'Set Profile': props<{ user: User }>(),
    'Get Profile': emptyProps(),
    'Set Settings': props<{ settings: Settings }>(),
    'Get Settings': emptyProps(),
    'Set Followers': props<{
      followers: PaginableUsersHttpResult;
    }>(),
    'Get Followers': props<{ page?: number; limit?: number }>(),
    'Set Followings': props<{
      followings: PaginableUsersHttpResult;
    }>(),
    'Get Followings': props<{ page?: number; limit?: number }>(),
    'Set equipments': props<{
      equipments: Equipment[];
    }>(),
    'Get Currency': props<{ currency: CurrencyType }>(),
    'Set Currency': props<{
      currency: CurrencyType;
    }>(),
    'Add Following': props<{
      user: SimpleUser;
    }>(),
    'Remove Following': props<{
      userId: number;
    }>(),
    'Get equipments': emptyProps(),
    Clear: emptyProps(),
  },
});
